import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ButtonGroup } from '@atlaskit/button';
import { PrimaryCTA } from '@atlassian/amkt-common';
import React, { PureComponent } from 'react';
import CancelButton from './CancelButton';
export default class ConfirmCancelFooter extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "render", () => /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(PrimaryCTA, {
      isLoading: this.props.isLoading,
      isDisabled: this.props.isPrimaryDisabled,
      onClick: this.props.onPrimaryCTAClick,
      buttonId: this.props.primaryButtonId
    }, this.props.primaryCTALabel), /*#__PURE__*/React.createElement(CancelButton, {
      isDisabled: this.props.isLoading,
      onClick: this.props.closeInstallDialog
    }, "Cancel")));
  }
}
_defineProperty(ConfirmCancelFooter, "defaultProps", {
  isPrimaryDisabled: false
});